import { Scenarios } from '@jfs/network'

const getBankList = {
  default: [
    {
      url: /common\/banks/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        CD: [
          {
            bankName: 'CD',
            bankBin: 'CED',
          },
          {
            bankName: 'Andhra Pradesh Grameena Vikash Bank',
            bankBin: '607198',
          },
        ],
        CW: [
          {
            bankName: 'CW Bank',
            bankBin: 'CWR',
          },
          { bankName: 'JPB', bankBin: '607884' },
          {
            bankName: 'Airtel Payments Bank',
            bankBin: '990320',
          },
          {
            bankName: 'Allahabad Bank',
            bankBin: '607105',
          },
        ],
        FT: [
          { bankName: 'JPB', bankBin: '607884' },
          {
            bankName: 'FT',
            bankBin: 'FTR',
          },
          {
            bankName: '100111',
            bankBin: '100111',
          },
        ],
        BI: [
          {
            bankName: 'BI',
            bankBin: 'BIR',
          },
          {
            bankName: '100111',
            bankBin: '100111',
          },
        ],
        MS: [
          {
            bankName: 'MS',
            bankBin: 'MSR',
          },
          {
            bankName: '100111',
            bankBin: '100111',
          },
        ],
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /common\/banks/,
      method: 'POST',
      responseCode: 500,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getBankList }
